import { Link } from "react-router-dom";

export type AIUpdatesProps = {
  heading?: string;
};

export default function AIUpdates({
  heading = "You daily AI download.",
}: AIUpdatesProps = {}) {
  return (
    <section className="w-full bg-black py-6 md:py-14 font-fira sm:py-20">
      <div className="mx-auto w-[90%] md:w-[80%]">
        <div className="relative overflow-hidden rounded-2xl md:rounded-3xl">
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet="/homepage/aiupdatesd.webp"
            />
            <img
              src="/homepage/aiupdatesm.webp"
              alt=""
              className="block h-auto w-full"
              loading="lazy"
              decoding="async"
            />
          </picture>

          <div className="absolute inset-0 flex flex-col items-start justify-start px-6 pt-8 sm:px-8 sm:pt-10 md:justify-center md:px-12 md:pt-0 ">
            <div className="max-w-md">
              <p className="mb-3 text-[11px] font-semibold uppercase tracking-[1.75px] text-[#1E1B4B] md:mb-4 md:text-xs">
                Daily AI Updates
              </p>
              <h2 className="mb-3 font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-[#1E1B4B] md:mb-4 md:text-[44px] lg:text-[48px]">
                {heading}
              </h2>
              <p className="mb-5 text-[13px] font-normal leading-relaxed text-[#1E1B4B]/65 md:mb-7 md:text-[16px]">
               A short PDF every morning on what changed in AI. Sent to your WhatsApp. Archived here so you can catch up anytime.
              </p>
              <Link
                to="/daily-ai-updates"
                className="w-full rounded-lg border border-[#1E1B4B]/30 px-6 py-2.5 text-sm font-semibold text-[#1E1B4B] transition hover:bg-[#1E1B4B]/5 md:py-3"
              >
                Explore more
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
